import React, { useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { List } from "@phosphor-icons/react";
import Sidebar from "@/components/Sidebar";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/Brand";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  const { user, loading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="flex flex-col items-center gap-4" data-testid="app-loading">
          <Wordmark size="md" />
          <div className="text-xs tracking-[0.22em] uppercase text-muted-foreground">Yükleniyor…</div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace state={{ from: location }} />;
  if (!user.onboarded && location.pathname !== "/karsilama") {
    return <Navigate to="/karsilama" replace />;
  }

  return (
    <div className="authenticated-shell min-h-screen flex bg-background">
      {/* Desktop sidebar */}
      <div className="hidden md:block sticky top-0 h-screen">
        <Sidebar />
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-40 flex">
          <div className="absolute inset-0 bg-[#07111F]/75" onClick={() => setMobileOpen(false)} />
          <div className="relative w-64 h-full">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      {/* Content */}
      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top bar */}
        <div className="md:hidden sticky top-0 z-30 border-b border-border/60 bg-background/95 backdrop-blur-xl">
          <div className="flex items-center justify-between px-4 py-3">
            <button onClick={() => setMobileOpen(true)} data-testid="mobile-menu" className="p-2 rounded-md hover:bg-accent">
              <List size={20} />
            </button>
            <Wordmark as="button" type="button" onClick={() => navigate("/panel")} size="xs" data-testid="mobile-brand" className="border-0 bg-transparent p-0 text-left cursor-pointer" />
            <div className="w-10" />
          </div>
        </div>

        <main className="flex-1 overflow-x-hidden">
          <Outlet />
        </main>
      </div>

      <Toaster richColors position="top-right" />
    </div>
  );
}
